<template>
<body id="page-top" class="body-bg">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio certificate-login-section" id="portfolio">
            <div class="container">
              <form @submit.prevent="handleSubmit">
                <div class="login-form">
                  <p class="h4">WHAT IS YOUR CERTIFICATE NUMBER?</p>
                  <div class="col-sm-10">
                <table>
                  <tr>
                  <td><input  id="digit1" type="text" maxlength="1" onkeypress="return isNumberKey(event)" onkeyup ="moveToNextInputDigit(this)"></td>
                  <td><input  id="digit2" type="text" maxlength="1" onkeypress="return isNumberKey(event)" onkeyup ="moveToNextInputDigit(this)"></td> 
                  <td><input  id="digit3" type="text" maxlength="1" onkeypress="return isNumberKey(event)" onkeyup ="moveToNextInputDigit(this)"></td>
                  <td><input  id="digit4" type="text" maxlength="1" onkeypress="return isNumberKey(event)" onkeyup ="moveToNextInputDigit(this)"></td>
                  <td><input  id="digit5" type="text" maxlength="1" onkeypress="return isNumberKey(event)" onkeyup ="moveToNextInputDigit(this)"></td> 
                  <td><input  id="digit6" type="text" maxlength="1" onkeypress="return isNumberKey(event)" onkeyup ="moveToNextInputDigit(this)"></td>
                  <td><input  id="digit7" type="text" maxlength="1" onkeypress="return isNumberKey(event)" onkeyup ="moveToNextInputDigit(this)"></td>
                  </tr> 
                  </table>
                    </div>
                </div>
                <div class="col-md-12">
                  <a style="float:left" type="button" class="btn btn-primary btn-lg"><router-link to="/member-login">CANCEL</router-link></a>
                  <a type="button" class="btn btn-primary btn-lg"><router-link to="/options-login">PREVIOUS</router-link></a>
                  <button class="btn btn-primary btn-lg">NEXT</button>
                  <!--<a type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">NEXT</router-link></a>-->
                </div>
                </form>
            </div>

                <div>
                  <b-modal ref="my-modal" id="modal-center" hide-footer title="Notice:">
                    <p class="my-4">{{returnMessage}}</p>
                  </b-modal>
              </div>
          </section>
</body>
</template>

<script>
import axios from 'axios';
export default {
  name: 'PhilLogin',
  data() {
    return {
      certNo: '',
      returnMessage: '',
      certInput: []
    }
  },
  methods: {
    addInput: function () {
      this.certInput.push({ value: '' });
    },
    async handleSubmit() {
      console.log(this.certInput);
        const response = await axios.post('/api/?action=member-login', {
           CertNo: this.certNo
        }, 
        );

        console.log(response);
        if (response.data.SuccessFlag == 'True'){
            localStorage.setItem('TokenID', response.data.TokenID)
            localStorage.setItem('CertNo', this.certNo)
            this.$router.push('/member-page');
        } else {
            this.returnMessage = response.data.MessageReturn
            this.showModal()
            console.log(this.returnMessage);
        }
    },
          showModal() {
            this.$refs['my-modal'].show()
          },
          hideModal() {
            this.$refs['my-modal'].hide()
          },
  }
}

var currentDigit = 1;
window.isNumberKey = function(evt){
    var charCode = (evt.which) ? evt.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;
    return true;
}

window.moveToNextInputDigit =  function(e){
     currentDigit = parseInt(e.id.replace("digit",""));
     currentDigit++;
     this.certInput.push(e.value); 
     if(e.value.length == 1 && currentDigit<=10 && document.getElementById("digit"+currentDigit).value.length!=1)
     {
      document.getElementById("digit"+currentDigit).focus();
     }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
table,td{
 border-collapse: collapse;
 padding:0;
}
td input{
width:90px;
height: 90px;
margin: 20px;
font-size: 30px;
text-align: center;

}


</style>
